/**
 * Labstep
 *
 * @module components/Permission/PermissionExclusiveFolderLoader
 * @desc Optionally loads the exclusive folder for an experiment workflow
 */

import { ReadOnMountHOC } from 'labstep-web/hoc/ReadOnMount';
import { ExperimentWorkflow } from 'labstep-web/models/experiment-workflow.model';
import { Folder } from 'labstep-web/models/folder.model';
import { ProtocolCollection } from 'labstep-web/models/protocol-collection.model';
import type React from 'react';
import type { PermissionExclusiveFolderLoaderProps } from './types';

export const PermissionExclusiveFolderLoader: React.FC<
  PermissionExclusiveFolderLoaderProps
> = ({ parentEntity, children, ...rest }) => {
  let folderType = null;
  if (parentEntity.entityName === ExperimentWorkflow.entityName) {
    folderType = 'experiment_workflow';
  } else if (
    parentEntity.entityName === ProtocolCollection.entityName
  ) {
    folderType = 'protocol_collection';
  }

  if (folderType) {
    return (
      <ReadOnMountHOC
        type="cursor"
        entityName={Folder.entityName}
        params={{
          is_exclusive: 1,
          type: folderType,
          owner_id: parentEntity.owner.guid,
          [`${folderType}_id`]: parentEntity.id,
        }}
        loading={false}
        children={({ entities }) => {
          if (entities.length > 0) {
            return children({
              exclusiveFolder: entities[0],
              ...rest,
            });
          }
          return null;
        }}
      />
    );
  }
  return children({
    ...rest,
  });
};
